<template>
  <v-container class="fill-height pb-0" >
    <v-card class="e-cardLeccion-intro e-elevation--4 e-border--radius fill-height">
      <v-card-text class="e-cardLeccion-intro-title py-2 justify-start d-flex-column">
        <p class="e-description-small mb-0 text-xs-left ">{{ tema }}</p>
        <p class="e-description-big mb-0 text-xs-left">{{ subtema }}</p>
      </v-card-text>
      <v-card-text class="pa-0">
        <img :src="require('@/assets/images/unit/lessons/' + image)" />
      </v-card-text>
      <v-card-text class="e-cardLeccion-intro-text px-4">
        <p class="text-xs-left parrafo" v-html="description"></p>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
export default {
  name: 'LeccionImage',
  props: {
    tema: {
      type: String,
      default: ''
    },
    subtema: {
      type: String,
      default: '‘ㄷ’'
    },
    image: {
      type: String,
      default: ''
    },
    description: {
      type: String,
      default: 'Lorem ipsum dolor sit amet consectetur adipiscing elit sollicitudin dapibus, nisl fames eleifend tincidunt sapien id fusce orci, conubia praesent ligula molestie risus class placerat sed. '
    }
  }
}
</script>
